import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { PERSONAS_TABLE_ACTIONS } from "../../PersonasHeader/enum";
import {
    PERSONA_DELETE_PERMISSION,
    PERSONA_UPDATE_PERMISSION,
} from "components/dashboard/ServiceModule/permissions";

const PersonasDropdown = ({ persona, handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value, persona)}
            options={[
                {
                    value: PERSONAS_TABLE_ACTIONS.EDIT,
                    label: "Edit",
                    baseResources: PERSONA_UPDATE_PERMISSION,
                },
                {
                    value: PERSONAS_TABLE_ACTIONS.DELETE,
                    label: "Delete",
                    baseResources: PERSONA_DELETE_PERMISSION,
                },
            ]}
        />
    );
};

export default PersonasDropdown;
